module.exports = __webpack_public_path__ + "img/jacket_3.0c2a023a.png";